__turbopack_context__.v({
  "catalogItemImagesSlider": "CatalogItemImagesSlider-module-scss-module__WfSZZG__catalogItemImagesSlider",
  "dot": "CatalogItemImagesSlider-module-scss-module__WfSZZG__dot",
  "dotActive": "CatalogItemImagesSlider-module-scss-module__WfSZZG__dotActive",
  "dots": "CatalogItemImagesSlider-module-scss-module__WfSZZG__dots",
  "inner": "CatalogItemImagesSlider-module-scss-module__WfSZZG__inner",
  "invisiblePanel": "CatalogItemImagesSlider-module-scss-module__WfSZZG__invisiblePanel",
  "item": "CatalogItemImagesSlider-module-scss-module__WfSZZG__item",
  "itemActive": "CatalogItemImagesSlider-module-scss-module__WfSZZG__itemActive",
  "items": "CatalogItemImagesSlider-module-scss-module__WfSZZG__items",
  "mainSlide": "CatalogItemImagesSlider-module-scss-module__WfSZZG__mainSlide",
});
